import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconEmail2Block: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconEmail2Block"><Path d="M12 19.5H2.5V4.5H21.5L21.5 7.25L12 12.0714L2.73768 7.37063" stroke="currentColor"/><Path d="M16.5251 19.4749C17.892 20.8417 20.108 20.8417 21.4749 19.4749C22.8417 18.108 22.8417 15.892 21.4749 14.5251M16.5251 19.4749C15.1583 18.108 15.1583 15.892 16.5251 14.5251C17.892 13.1583 20.108 13.1583 21.4749 14.5251M16.5251 19.4749L21.4749 14.5251" stroke="currentColor"/></CentralIconBase>;
});

export default IconEmail2Block;
